//POST INDIVISUAL CATEGORY
export const POST_CATEGORY_FETCH_START = "POST_CATEGORY_FETCH_START";
export const POST_CATEGORY_FETCH_SUCCESS = "POST_CATEGORY_FETCH_SUCCESS";
export const POST_CATEGORY_FETCH_FAILURE = "POST_CATEGORY_FETCH_FAILURE";

//GET ALL CATEGORY
export const ALL_CATEGORY_GET_START = "ALL_CATEGORY_GET_START";
export const ALL_CATEGORY_GET_SUCCESS = "ALL_CATEGORY_GET_SUCCESS";
export const ALL_CATEGORY_GET_FAILURE = "ALL_CATEGORY_GET_FAILURE";

//GET INDIVIDUAL CATEGORY
export const GET_SINGLE_CATEGORY_START="GET_SINGLE_CATEGORY_START";
export const GET_SINGLE_CATEGORY_SUCCESS="GET_SINGLE_CATEGORY_SUCCESS";
export const GET_SINGLE_CATEGORY_FAILURE="GET_SINGLE_CATEGORY_FAILURE";

//DELETE AND RESTORE CATEGORY
export const DEL_RES_CATEGORY_START="DEL_RES_CATEGORY_START";
export const DEL_RES_CATEGORY_SUCCESS="DEL_RES_CATEGORY_SUCCESS";
export const DEL_RES_CATEGORY_FAILURE="DEL_RES_CATEGORY_FAILURE";